<template>
  <div data-test="topic">
    <DynamicForm
      :formId="formId"
      :isNested="true"
      :editable="editable"
    />
    <AppButton
      v-if="editable"
      variant="danger"
      @click="$emit('delete')"
    >
      <AppIcon name="delete" /> Delete Topic
    </AppButton>
  </div>
</template>

<script>
import useFormListNestedForm from './composables/useFormListNestedForm'

export default {
  components: {
    DynamicForm: () => import('@/components/DynamicForms/DynamicForm'),
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    index: {
      type: Number,
      required: true,
    },
    formValue: {
      type: Object,
      default: () => ({}),
    },
    config: {
      type: Object,
      default: () => ({}),
    },
    editable: {
      type: Boolean,
      default: false,
    },
    iteration: {
      type: Number,
      default: 0,
    },
    nestedMode: {
      type: Boolean,
      default: true,
    },
  },
  setup (props, { root, emit }) {
    const {
      formId,
    } = useFormListNestedForm({ props, emit, collection: 'topics' })

    return {
      formId,
    }
  },
}
</script>
